// Arabic strings for the redesigned Preparation (prep-sheet) workspace
// (components/Reports/Operations/PreparationWorkspace).
const trans = {
  // Page chrome — unique section key so it doesn't collide with the global
  // "Preparation" (= "تحضير", the order-prep STATUS used across Orders/B2B).
  "Preparation report": "قائمة التحضير",
  "What to prepare for orders due in the selected window (by expected delivery time).":
    "ما يجب تحضيره للطلبات المستحقة في الفترة المحددة (حسب وقت التسليم المتوقع).",

  // Date presets
  Today: "اليوم",
  Tomorrow: "غدًا",
  "This week": "هذا الأسبوع",
  Custom: "مخصص",

  // Group-by options
  "By date": "حسب التاريخ",
  "By date + time": "حسب التاريخ والوقت",
  "By area": "حسب المنطقة",
  "By section": "حسب القسم",
  "By driver": "حسب السائق",
  "By business": "حسب الشركة",
  "By business + branch": "حسب الشركة والفرع",
  "By option groups": "حسب مجموعات الخيارات",
  "By customer + option groups": "حسب العميل ومجموعات الخيارات",
  "No grouping": "بدون تجميع",

  // Group headers / sentinels
  "All products": "جميع المنتجات",
  "No group": "بدون مجموعة",
  "No Group": "بدون مجموعة",
  "No date": "بدون تاريخ",
  "No Area": "بدون منطقة",
  "No time": "بدون وقت",
  "No Section": "بدون قسم",

  // Table columns
  Product: "المنتج",
  Options: "الخيارات",
  Option: "الخيار",
  Choice: "الاختيار",
  Quantity: "الكمية",
  Group: "المجموعة",

  // Summary strip
  "Items to prepare": "العناصر المطلوب تحضيرها",
  "Orders covered": "الطلبات المشمولة",
  "Distinct products": "منتجات مختلفة",
  Groups: "المجموعات",
  items: "عنصر",
  lines: "أسطر",

  // Actions
  "Print A4": "طباعة A4",
  Print: "طباعة",
  Refresh: "تحديث",
  Export: "تصدير",
  Excel: "إكسل",
  "Search products, options or groups…": "ابحث عن المنتجات أو الخيارات أو المجموعات…",
  "No data": "لا توجد بيانات",

  // Filters
  Filters: "عوامل التصفية",
  "All branches": "جميع الفروع",
  "All orders": "جميع الطلبات",
  "All drivers": "جميع السائقين",
  "All statuses": "جميع الحالات",
  Customers: "العملاء",
  Businesses: "الشركات",

  // Statuses
  Received: "مستلم",
  Preparing: "يتم تحضيره",
  "Driver Pending": "بانتظار السائق",
  Complete: "مكتمل",
  Cancelled: "ملغي",
  Refunded: "مسترد",

  // Stickers (customer + option groups)
  "Nothing to prepare for this selection": "لا يوجد ما يتم تحضيره لهذا التحديد",
  selected: "محدد",
  "Print labels": "طباعة الملصقات",
  Clear: "مسح",
  "Select all": "تحديد الكل",
  customers: "عملاء",
  Customer: "العميل",
  Phone: "الهاتف",
  Time: "الوقت",

  // Date-range limit
  "Preparation is limited to the last 14 days.": "التحضير متاح لآخر 14 يومًا فقط.",
};

export default trans;
